import moment from "moment";
import { ADD_ICON } from "../../cufront-assets/icons/Icons";
import "../css/PatientInfo.css";
import NameAvatar from "../../all-patient/components/NameAvatar";
import { calculateAgeString } from "../../new_appointment/_helper/utils.js/utils";
import { LuMinus, LuPlus } from "react-icons/lu";
import { useEffect, useState } from "react";
import { useMediaQuery } from "react-responsive";
import PatientDetailsCardSm from "../../all-patient/components/PatientDetailsCardSm";
import { getImageURL } from "../../_helper/utils/image";
import { FaHeart, FaRegHeart } from "react-icons/fa6";
import CuTooltip from "../../common_component/component/CuTooltip";
import { useUpdateItem } from "../../_helper/actions/mutation/items";
import { ApiEndPoint } from "../../_helper/constant/api-types";
import { useSearchParams } from "react-router-dom";
import { toast } from "react-toastify";
import { useAtom } from "jotai";
import { clinicAtom } from "../../_helper/constant/constant-atom";
import { useCurrentRole } from "../../_helper/constant/Permission";
import { calculateAge } from "../../_helper/utils/utils";

const PatientInfo = ({
  name,
  dob,
  gender,
  phone,
  email,
  profile_image,
  isFavorite,
}) => {
  const sm = useMediaQuery({ query: "(max-width:635px)" });
  const nameLetter = name?.split("")[0];

  // const { role_id } = useCurrentRole();
  const { doctor_personal_details } = useCurrentRole();

  const [clinic] = useAtom(clinicAtom);

  const [searchParams] = useSearchParams();

  const userId = searchParams.get("userId");

  const [isExpanded, setIsExpanded] = useState(false);

  const [isfavorite, setIsFavorite] = useState(isFavorite);

  //("IS Favroite", isFavorite);

  const patchDoctorDetails = useUpdateItem(
    `${ApiEndPoint?.USERS}doctor_personal_detail/`,
    ApiEndPoint?.CLINIC
  );

  const handleFavoritePatient = (id, action) => {
    const payload = {
      action: "patchDoctorPersonalDetails",
      id: doctor_personal_details?.id,
      clinic_id: clinic?.id,
      backend: "True",
      special_patient: [userId],
      special_patient_action: action === "add" ? "add" : "remove",
    };

    patchDoctorDetails.mutate(
      { id: null, data: payload },
      {
        onSuccess: (data) => {
          if (action === "add") {
            setIsFavorite(true);
            toast.success("Marked as a Special Patient");
          } else {
            setIsFavorite(false);
            toast.success("Patient Unmarked");
          }
          // refetch();
        },
        onError: (err) => {
          toast.error(err.response.data.message);
        },
      }
    );
  };

  useEffect(() => {
    setIsFavorite(isFavorite);
  }, [isFavorite]);

  return !sm ? (
    <>
      <div className="special_patient_container">
        <div
          onClick={() =>
            handleFavoritePatient(userId, isfavorite ? "remove" : "add")
          }
          className="cursor-pointer"
        >
          {isfavorite ? (
            <FaHeart
              className="text-2xl ml-3 align-middle"
              style={{ color: "#77db8f" }}
            />
          ) : (
            <CuTooltip text="Add to Favorite" position="left">
              <FaRegHeart
                className="text-2xl ml-3 align-middle"
                style={{ color: "#77db8f" }}
              />
            </CuTooltip>
          )}
        </div>
      </div>
      {isExpanded && (
        <div className="cu-consultation-patientinfo-container">
          <span
            className="absolute top-[1%] right-[1.5%] cursor-pointer"
            onClick={() => setIsExpanded(!isExpanded)}
          >
            <LuMinus size={25} />
            {/* {isExpanded ? <FaRegWindowMinimize /> : <FaRegWindowMaximize />} */}
          </span>
          <div className="cu-consultation-patient-profile-img overflow-hidden">
            {profile_image ? (
              <img
                className="w-full h-full "
                src={getImageURL(profile_image)}
                alt=""
              />
            ) : (
              <NameAvatar name={nameLetter} />
            )}
          </div>
          <div className="cu-consultation-patient-details">
            <div className="flex items-center">
              <div className="cu-consultation-patient-name">{name}</div>
            </div>

            <div className="cu-consultation-patient-otherinfo">
              <div className="cu-consultation-patient-otherinfo-field">
                <span className="cu-consultation-patient-otherinfo-label">
                  Date of birth
                </span>
                <span className="cu-consultation-patient-otherinfo-data">
                  {dob ? moment(dob).format("DD MMM YYYY") : "-"}
                </span>
              </div>
              <div className="cu-consultation-patient-otherinfo-field">
                <span className="cu-consultation-patient-otherinfo-label">
                  Age
                </span>
                <span className="cu-consultation-patient-otherinfo-data">
                  {dob ? calculateAgeString(dob) : "-"}
                </span>
              </div>
              <div className="cu-consultation-patient-otherinfo-field">
                <span className="cu-consultation-patient-otherinfo-label">
                  Gender
                </span>
                <span className="cu-consultation-patient-otherinfo-data">
                  {gender ? gender : "-"}
                </span>
              </div>
              <div className="cu-consultation-patient-otherinfo-field">
                <span className="cu-consultation-patient-otherinfo-label">
                  Mobile Number
                </span>
                <span className="cu-consultation-patient-otherinfo-data">
                  {phone}
                </span>
              </div>
              <div className="cu-consultation-patient-otherinfo-field">
                <span className="cu-consultation-patient-otherinfo-label">
                  Email
                </span>
                <span className="cu-consultation-patient-otherinfo-data">
                  {email ? email : "-"}
                </span>
              </div>
            </div>
            <div className="cu-consultation-patientinfo-btns">
              <button className="cu-consultation-patientinfo-btn">
                <span>
                  <img
                    src={ADD_ICON}
                    alt="add"
                    className="cu-consultation-patientinfo-btn-icon"
                  />
                </span>
                <span>Appointment</span>
              </button>
              <button className="cu-consultation-patientinfo-btn">
                <span>
                  <img
                    src={ADD_ICON}
                    alt="add"
                    className="cu-consultation-patientinfo-btn-icon"
                  />
                </span>
                <span>Prescription</span>
              </button>
              <button className="cu-consultation-patientinfo-btn">
                <span>
                  <img
                    src={ADD_ICON}
                    alt="add"
                    className="cu-consultation-patientinfo-btn-icon"
                  />
                </span>
                <span>Document</span>
              </button>
              <button className="cu-consultation-patientinfo-btn">
                <span>
                  <img
                    src={ADD_ICON}
                    alt="add"
                    className="cu-consultation-patientinfo-btn-icon"
                  />
                </span>
                <span>Forms</span>
              </button>
              <button className="cu-consultation-patientinfo-btn">
                <span>
                  <img
                    src={ADD_ICON}
                    alt="add"
                    className="cu-consultation-patientinfo-btn-icon"
                  />
                </span>
                <span>Refer</span>
              </button>
              <button className="cu-consultation-patientinfo-btn">
                <span>
                  <img
                    src={ADD_ICON}
                    alt="add"
                    className="cu-consultation-patientinfo-btn-icon"
                  />
                </span>
                <span>Notes</span>
              </button>
            </div>
          </div>
        </div>
      )}
      {!isExpanded && (
        <div className="flex items-center gap-10 border-b p-2">
          <span
            className="absolute top-[1%] right-[1.5%] cursor-pointer"
            onClick={() => setIsExpanded(!isExpanded)}
          >
            <LuPlus size={25} />
          </span>
          <div className="w-[50px] h-[50px] rounded-full overflow-hidden border">
            {profile_image ? (
              <img
                className="w-full h-full "
                src={getImageURL(profile_image)}
                alt=""
              />
            ) : (
              <NameAvatar name={nameLetter} type="rounded" />
            )}
          </div>
          <div className="flex flex-col gap-1">
            {/* <span className="cu-consultation-patient-otherinfo-label">
              Name
            </span> */}
            <span className="cu-consultation-patient-otherinfo-data">
              {name}
            </span>
          </div>
          <div className="flex flex-col gap-1">
            {/* <span className="cu-consultation-patient-otherinfo-label">Age</span> */}
            <span className="cu-consultation-patient-otherinfo-data">
              {dob
                ? calculateAge(dob).years !== 0
                  ? `${calculateAge(dob).years} Yrs`
                  : calculateAge(dob).months !== 0
                    ? `${calculateAge(dob).months} M`
                    : `${calculateAge(dob).days} D`
                : "-"}
            </span>
          </div>
          <div className="flex flex-col gap-1">
            {/* <span className="cu-consultation-patient-otherinfo-label">
              Gender
            </span> */}
            <span className="cu-consultation-patient-otherinfo-data">
              {gender}
            </span>
          </div>
          <div className="flex flex-col gap-1">
            {/* <span className="cu-consultation-patient-otherinfo-label">
              Mobile
            </span> */}
            <span className="cu-consultation-patient-otherinfo-data">
              {phone}
            </span>
          </div>
        </div>
      )}
    </>
  ) : (
    <PatientDetailsCardSm
      name={name}
      phone={phone}
      email={email}
      profile_image={profile_image}
      isFavorite={isfavorite}
    />
  );
};

export default PatientInfo;
